const BASE = 'svg';

export const SVG_QUERY_KEYS = {
    getSvgData: (url: string) => (url ? [BASE, 'get-svg-data', url] : [BASE, 'get-svg-data']),
};
